module.exports = __webpack_public_path__ + "static/media/Banner_blk.c428ff7e.jpg";